/** @format */

import React, { useEffect, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { PageContainer, LoadingPage, Empty } from 'components';
import { useQuery } from 'hooks';
import { Grid } from '@mui/material';
import { URL_PAY as payPodURL, URL_REACT_APP as appURL } from 'config';
import Services from './services/DirectDebitServices';
import { GrantItem } from './components';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';

const CHECK_ACTIVATION_STATE = 'DirectDebitCallBack';

const TransferCredit = () => {
  // -- STATES --//
  const [debits, setDebits] = useState([]);
  const [wallets, setWallets] = useState([]);
  const [loading, setLoading] = useState(false);
  const actionsList =
    getDynamicObjectAction([
      'directDebitAccountDigitalPage'

    ])
  // -- HOOKS --//

  const classes = useStyles();

  const query = useQuery();

  useEffect(() => {
    if (actionsList['directDebitAccountDigitalPage']) {
      getData();
    }

  }, []);

  useEffect(() => {
    if (query?.get('state')) {
      handleBankCallBack(query.get('state'));
    }
  }, [query]);

  //* * API REQUESTS *//
  const getData = async () => {
    setLoading(true);
    const walletsList = await getWallets();
    if (!walletsList) {
      setLoading(false);
      return;
    }
    let fullList = [];

    for (const w of walletsList) {
      const wGrants = await getGrantsList(w.wallet);
      if (wGrants) {
        fullList = [...fullList, ...wGrants];
      } else {
        setLoading(false);
        return;
      }
    }
    setDebits(fullList);
    setLoading(false);
  };

  const getGrantsList = async (wallet) => {
    if (!wallet) return;
    try {
      const query = { wallet };
      const res = await Services.getWithdrawRules(query);
      return res?.result ?? [];
    } catch (error) {

      return null;
    }
  };

  const getWallets = async () => {
    try {
      const result = await Services.getCredit();
      setWallets(result?.result?.customerAmountSrvs ?? []);
      return result?.result?.customerAmountSrvs ?? [];
    } catch (error) {

      return null;
    }
  };


  const handleBankCallBack = (queryState) => {
    try {
      const incomingState = atob(queryState);
      if (incomingState === CHECK_ACTIVATION_STATE) {
        window.open(
          `${payPodURL}/v1/pbc/IssueDirectDebitMandate?wallet=PODLAND_WALLET&redirectUri=${appURL}/digital-account/direct-debit?activated=true`,
          '_self',
        );
      }
    } catch (error) {
      console.log('error', error);
    }
  };
  const hintText =
    'مشاهده لیست مجوزهای برداشت از حساب بانکی پاسارگاد و غیرفعال‌سازی هر مورد، در این بخش امکان پذیر است.';

  return (
    <PageContainer
      title="مجوزهای برداشت مستقیم از حساب بانکی"
      className={classes.root}
      description={hintText}
      breadcrumbs={constBreadCrumbsTitle.DIRECT_DEBIT}
    >
      {actionsList['directDebitAccountDigitalPage'] && (
        loading ? (
          <LoadingPage />
        ) : (
          <>
            <Grid container spacing={2}>
              {debits?.length === 0 ? <Empty label="هیچ مجوز برداشتی یافت نشد!" /> : null}
              {debits?.map((item, k) => (
                <Grid item xs={12} md={6} lg={4}>
                  <GrantItem
                    data={item}
                    wallets={wallets ?? []}
                    key={k}
                    refreshList={getGrantsList}
                  />
                </Grid>
              ))}

            </Grid>
          </>
        )
      )}
    </PageContainer>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {},
}));

export default TransferCredit;

// MOCK DATA
